const put = (name: string, value?: string, days?: number, domain = '.meupasseiovirtual.com', path = '/') => {
    let expires = '';

    if (days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${(value || "")}${expires}; domain=${domain}; path=${path}`;
};

const get = (name: string) => {
    name = `${name}=`;

    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.indexOf(name) === 0)
            return cookie.substring(name.length, cookie.length);
    }

    return null;
};

const remove = (name: string) => {
    document.cookie = `${name}=; Max-Age=-99999999`;
};

const cookie = { put, get, remove };

export default cookie;
